module.exports = __webpack_public_path__ + "images/5622abb91675d115ea26c3dde49994198da26492419dbd37826b6e93cac1049f.svg";